<template>
  <div>
  </div>
</template>

<script>
import { CityControls } from '../City/CityControls'
import O3DG2 from '../../Reusable/O3DG2'
export default {
  mixins: [
    O3DG2
  ],
  data () {
    return {
    }
  },
  mounted () {
    let controls = new CityControls({ camera: this.ctx.camera, touchdiv: this.ctx.touchdiv, onLoop: this.onLoop, onClean: this.onClean })
    this.$emit('controls', controls)
  }
}
</script>

<style>

</style>